module.exports = __webpack_public_path__ + "img/news-1.30964faa.png";